import React from "react";
import BookingFlow from "@/components/BookingFlow";

const VelaBooking = () => <BookingFlow brand="vela" />;
export default VelaBooking;
